<template>
    <div :id="randomId" name="content" type="text/plain"></div>
</template>

<script>
import config from '../../common/config.js';
    export default {
        name: 'Editor',
        data() {
            return {
                // 为了避免麻烦，每个编辑器实例都用不同的 id
                randomId: `editor_${(Math.random() * 100000000000000000)}`,
                instance: null,
            };
        },
        created() {
            if (window.UE !== undefined) {
                // 如果全局对象存在，说明编辑器代码已经初始化完成，直接加载编辑器
                this.initEditor();
            } else {
                // 如果全局对象不存在，说明编辑器代码还没有加载完成，需要加载编辑器代码
                this.insertScriptTag();
            }
        },
        beforeDestroy() {
            // 组件销毁的时候，要销毁 UEditor 实例
            if (this.instance !== null && this.instance.destroy) {
                this.instance.destroy();
            }
        },
        methods: {
            insertScriptTag() {
                const loading = [];
                const self = this;
                // 等待代码加载完成后初始化编辑器
                Promise.all(loading).then(() => {
                    setTimeout(() => {
                        self.initEditor();
                    }, 300);
                });
            },
            initEditor() {
                const self = this;
                if (self.instance === null) {
                    // Vue 异步执行 DOM 更新，这样一来代码执行到这里的时候可能 template 里面的 script 标签还没真正创建
                    // 所以，我们只能在 nextTick 里面初始化 UEditor
                    self.$nextTick(() => {
                        self.instance = window.UE.getEditor(self.randomId, self.config);
                        // 绑定事件，当 UEditor 初始化完成后，将编辑器实例通过自定义的 ready 事件交出去
                        self.instance.addListener('contentChange', () => {
                            self.$emit('input', self.instance.getContent());
                            self.$emit('setDetail',self.instance.getContent());//setDetail为父组件方法
                        });
                        self.instance.addListener('ready', () => {
                            self.instance.setContent(self.value);
                            self.$emit('ready', self.instance);
                        });
                    });
                }
            },
            setEditer(content){
                this.instance.setContent(content);
                this.$emit('ready', self.instance);
            }
        },
        props: {
            config: {
                // UEditor 配置项
                type: Object,
                default() {
                    return {
                        initialFrameHeight: 400,
                        initialFrameWidth:'100%',
                        topOffset: 89,
                    };
                },
            },
            path: {
                // UEditor 代码的路径
                type: String,
                default: config.url+'/neditor/',
            },
            value: {
                type: String,
                default: '',
            },
        },
    };
</script>